export const QUEUE_NOTIFICATION = "notif/QUEUE";
export const REMOVE_NOTIFICATION = "notif/REM";

export const SET_LOAD_STATE = "notif/SET_LOAD_STATE";
export const RESET_LOADING_STATE = "notif/RESET_LOADING_STATE";